<template>
    <div v-bind:class="{'isFiltered': isFiltered}" class="filter-button" @click.prevent ="showFilterContainer">
        <a href="#" class="black">
            <i class="far fa-filter"></i>
            <div>{{ $t('web.filter-button.filter') }}</div>
            <div class="filter-number" v-if="isFiltered">{{filterNumber}}</div>
            <i class="far fa-angle-down"></i>
        </a>
    </div>
</template>

<script>
    export default {
        props: {
        },

        data(){
            return {
                isFiltered: false,
                filterNumber: Number,
            }
        },

        methods: {
            showFilterContainer(){
                this.$events.$emit('travel-activities-filter-container:toggle');
            }
        },

        mounted() {
            this.filterNumber = 0;
            const query = window.location.search;
            const paramString = new URLSearchParams(query);
            paramString.forEach( (value, key) => {
                if (key === 'filterprovider' ){
                    this.filterNumber = this.filterNumber + value.split(',').length;
                    this.isFiltered = true;
                }
                if (key === 'price'){
                    this.filterNumber++;
                    this.isFiltered = true;
                }
                if (key === 'categories'){
                    console.log(this.filterNumber);
                    this.filterNumber = this.filterNumber + value.split(',').length;

                    this.isFiltered = true;
                }
            });
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";
    .filter-button{
        display: inline-block;
        border: 1px solid #707070;
        box-sizing: border-box;
        border-radius: 8px;
        padding: 6px 12px;
        @include responsive(){
            width: 100%;
            display: flex;
            justify-content: center;
        }
        a{
            color: #000;
            display: flex;
            align-items: baseline;
            &:hover{
                color: unset;
            }
        }
        div{
            margin: 0 4px;
        }
    }

    .isFiltered{
        background: #3155A6;
        a {
            color: white !important;
        }
        .filter-number{
            border-radius: 100%;
            padding: 2px 8px;
            background: white;
            color: black;
        }
    }

</style>
